<script>
import {ElMessage, ElNotification} from "element-plus";
import http from "@/http";
import {loadYmap} from "vue-yandex-maps";

export default {
  name: "MobileMonitoringForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        latitude: 0,
        longitude: 0,
        initiative_id: null,
        address_title: null,
        comment: null,
        images: []
      },
      // initiative_id: "5a011b81-9bc1-4528-9d1e-1bad3ccb6b05",
      locationDialogVisible: false,
      locationDialogTitle: "Manzilni tanlang",
      settings: {
        apiKey: '4c616bd5-36f2-4c27-9e16-0eed43779920',
        lang: 'uz_UZ',
        coordorder: 'latlong',
        version: '2.1'
      },
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      rules: {
        address_title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        comment: [{required: true, message: "Majburiy maydon", trigger: "blur"}]
      }
    }
  },
  methods: {
    getCurrentLocation() {
      this.loading = true;
      try {
        window.navigator.geolocation.getCurrentPosition(async coords => {
          if (!this.form.id) {
            this.form.latitude = coords.coords.latitude;
            this.form.longitude = coords.coords.longitude;
            await this.addressInfo(coords.coords.latitude, coords.coords.longitude)
          }
        }, (error) => {
          ElNotification.error(error.message || "Manzilingizni aniqlashga ruxsat bermadingiz!");
        });
      } catch (err) {
        ElNotification.error(err.message || "Manzilingizni aniqlay olmadik!");
      } finally {
        this.loading = false
      }
    },
    // async onClickMap(e) {
    //   if (e.get) {
    //     const clickedCoords = [e.get('coords')[0], e.get('coords')[1]]
    //     this.form.latitude = clickedCoords[0];
    //     this.form.longitude = clickedCoords[1];
    //     await this.addressInfo(clickedCoords[0], clickedCoords[1])
    //   }
    // },
    async addressInfo(lat, long) {
      const geocoder = ymaps.geocode([lat, long]);
      const response = await geocoder
      const geoObject = response.geoObjects.get(0)

      const address = {
        city: geoObject.getLocalities().join(', '),
        region: geoObject.getAdministrativeAreas().join(', '),
        street: geoObject.getThoroughfare() || '',
        houseNumber: geoObject.getPremiseNumber() || ''
      };
      this.form.address_title = address?.region + '  ' + address?.city + '  ' + address?.street + ' ' + address?.houseNumber
    },
    changeLocation() {
      this.locationDialogVisible = !this.locationDialogVisible;
    },
    onClickRemoveImg(index) {
      this.form.images.splice(index, 1)
    },
    uploadImg(event) {
      this.loading = true;
      const file = event.target.files[0]
      const image = new FormData()
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      this.loading = true
      image.append('file', file)
      http
          .post(url, image, {
            headers: {
              Authorization: this.$store.state.accessToken,
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({data}) => {
            this.form.images.push(data.hashId);
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            this.loading = false
          })
    },
    handleImageUpload() {
      const fileInputId = document.getElementById('fileInputRef');
      fileInputId.click()
    },
    onSubmit() {
      if (!this.form.latitude && !this.form.latitude) {
        ElNotification({
          title: "Iltimos",
          message: "Manzilni xaritadan tanlang",
          type: "warning",
        });
        return false
      }
      if (!this.form.images.length) {
        ElNotification({
          title: "Iltimos",
          message: "Rasim yuklang",
          type: "warning",
        });
        return false
      }
      if (this.form.images?.length < 2) {
        ElNotification({
          title: "Iltimos",
          message: "Kamida 2 ta rasim yuklashingiz kerak",
          type: "warning",
        });
        return false
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/initiatives/mobile-monitoring/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/initiatives/mobile-monitoring", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    },
    getMonitoringById() {
      this.loading = true;
      this.$http
          .get(`api/v1/initiatives/mobile-monitoring/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },

  async mounted() {
    if (this.$route.params.initiative) {
      this.form.initiative_id = this.$route.params.initiative
    }
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getMonitoringById()
    }
    await loadYmap(this.settings);
    this.getCurrentLocation()
  }
}
</script>

<template>
  <div class="accept-initiative">
    <div class="form" v-loading="loading">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-position="top"
              style="width: 100%"
              status-icon
          >
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="Manzil" prop="address_title">
                  <el-input disabled size="large" v-model="form.address_title"
                            placeholder="Manzil" clearable
                            style="width: 100%">
                    <template #append>
                      <el-button @click="changeLocation">Ko'rish</el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="Izoh" prop="comment">
                  <el-input
                      style="width: 100%"
                      size="large"
                      class="form-input"
                      placeholder="Kiriting"
                      v-model="form.comment"
                      type="textarea"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button size="large" id="upload_img" class="info-btn form-input" @click="handleImageUpload">
                  <input type="file" id="fileInputRef" accept="image/jpeg,image/jpg,image/png" @change="uploadImg"
                         style="display: none"/>
                  <img src="@/assets/images/gallery.svg" alt="gallery" style="margin-right: 4px"/>
                  Rasm yuklang
                </el-button>
              </el-col>
              <div class="images">
                <div class="image-item"
                     v-for="(hash,index) in form.images"
                     :key="hash">
                  <el-image
                      style="height: 180px;width: 200px; border:1px solid #e4e4e4; border-radius: 4px;"
                      :src="baseUrl+hash"
                      fit="contain"/>
                  <el-button size="small"
                             class="remove-img"
                             type="danger"
                             @click="onClickRemoveImg(index)"
                  >X
                  </el-button>
                </div>
              </div>
            </el-row>
            <el-row :gutter="10" style="margin-top: 20px">
              <el-col :span="24">
                <el-form-item>
                  <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                  >Orqaga
                  </el-button
                  >
                  <el-button class="custom-btn" type="primary" @click="onSubmit"
                  >Saqlash
                  </el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
  <el-dialog style="width: 70%" v-model="locationDialogVisible" align-center
             :title="form.address_title?form.address_title:locationDialogTitle">
    <yandex-map style="width: 100%; height: calc(100vh - 150px);"
                :coords="[form.latitude,form.longitude]"
                :zoom="10"
                :settings="settings"
                :controls="['fullscreenControl', 'zoomControl', 'typeSelector']"
    >
      <ymap-marker :coords="[form.latitude,form.longitude]" marker-id="marker"/>
    </yandex-map>
  </el-dialog>
</template>

<style scoped lang="scss">

.form-fieldset {
  border: 1px solid rgba(137, 141, 141, 0.2);
  border-radius: 5px;
  padding: 5px 8px;

  &:nth-child(3) {
    margin: 20px 0;
  }

  legend {
    font-style: italic;
    font-weight: bold;
  }
}

#upload_img {
  margin-bottom: 10px;
  width: 100%;
}

.images {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }

    .remove-img {
      position: absolute;
      right: -10px;
      top: -8px;
      font-size: 12px;
      font-weight: bolder;
    }
  }
}
</style>
